var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRecent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "recent_svg__a",
  d: "M0 0h24v24H0V13.997l6-2.163V8.37H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "recent_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#recent_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.528 6.584v5.256l4.488 2.664-.744 1.272-5.256-3.192v-6zM12 19.616q2.16 0 4.032-1.104a7.77 7.77 0 0 0 2.88-2.88 7.8 7.8 0 0 0 1.104-4.032q0-2.16-1.104-4.032a7.77 7.77 0 0 0-2.88-2.88A7.8 7.8 0 0 0 12 3.584q-2.16 0-4.032 1.104a7.77 7.77 0 0 0-2.88 2.88A7.8 7.8 0 0 0 3.984 11.6q0 2.16 1.104 4.032a7.77 7.77 0 0 0 2.88 2.88A7.8 7.8 0 0 0 12 19.616m0-18q2.736 0 5.064 1.368a9.46 9.46 0 0 1 3.552 3.552 9.8 9.8 0 0 1 1.368 5.064 9.8 9.8 0 0 1-1.368 5.064 9.46 9.46 0 0 1-3.552 3.552A9.8 9.8 0 0 1 12 21.584a9.8 9.8 0 0 1-5.064-1.368 9.64 9.64 0 0 1-3.552-3.576 9.8 9.8 0 0 1-1.368-5.04q0-2.712 1.368-5.04A9.8 9.8 0 0 1 6.96 2.984 9.8 9.8 0 0 1 12 1.616",
  mask: "url(#recent_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.436 10.334 1.838 5.37l5.196 3z"
}))));
export default SvgRecent;